// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f7be5b23","885":"64b3cd8f"}[chunkId] + ".chunk.js";
};